// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PlanPrice from './PlanPrice';
import styles from './PlanDetails.css';
import Price from '../common/Price';
import classNames from 'classnames';

type OwnProps = {
  title?: React$Element<typeof FormattedMessage> | string,
  monthlyPrice: number,
  relativeDiscount?: number,
  benefits: Array<{
    key: string,
    value: React$Element<typeof FormattedMessage> | string,
  }>,
  exclusions?: Array<{
    key: string,
    value: React$Element<typeof FormattedMessage> | string,
  }>,
  isTrialAvailable: boolean,
  trialDurationDays: number,
  priceTag?: React$Element<any>,
};

type Props = OwnProps;

const PlanDetails = ({
  title,
  benefits,
  exclusions,
  monthlyPrice,
  relativeDiscount,
  isTrialAvailable,
  trialDurationDays,
  priceTag,
}: Props) => {
  return (
    <div className={styles.container}>
      {title && <h2 className="fz--gamma">{title}</h2>}
      {isTrialAvailable && (
        <span className={styles.trial} data-test="plan-details.trial.price">
          <FormattedMessage
            id="premium.plan-details.free-trial"
            defaultMessage="{price} for {trialDurationDays} days"
            values={{
              price: <Price price={0} />,
              trialDurationDays,
            }}
          />
        </span>
      )}
      <span
        className={classNames(styles.price, {
          [styles.priceDimmed]: isTrialAvailable,
        })}
      >
        {isTrialAvailable && (
          <React.Fragment>
            <FormattedMessage id="premium.plan-details.then" defaultMessage="then" />
            &nbsp;
          </React.Fragment>
        )}
        <PlanPrice
          price={monthlyPrice}
          relativeDiscount={relativeDiscount}
          interval="monthly"
          priceTag={priceTag}
        />
      </span>
      <ul className={styles.objectives}>
        {benefits.map(({ key, value }) => (
          <li key={key} className={styles.benefit}>
            {value}
          </li>
        ))}
        {exclusions &&
          exclusions.map(({ key, value }) => (
            <li key={key} className={styles.exclusion}>
              {value}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default PlanDetails;
